@if (bannerMessage()) {
    <div class="update-bar trial-expiry">
        <span [innerHTML]="bannerMessage()"></span>
        <span> — </span>
        <a [routerLink]="['/billing']" data-testid="topbar-device-trial-banner-billing-link">{{ "navbar.setup_billing" | translate }}</a>
        <button class="trial-dismiss-btn" (click)="dismiss()" aria-label="Dismiss" data-testid="topbar-device-trial-banner-dismiss-button">&#x2715;</button>
    </div>
}
